import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import Login from './views/login.vue'
import PaymentConfirmation from './views/payment-confirmation.vue'
import PaymentInformation from './views/payment-information.vue'
import PaymentMethod from './views/payment-method.vue'
import VehicleDetail from './views/vehicle-details.vue'
import Home from './views/home.vue'
import ServiceOverview from './views/services-overview.vue'
import VehiclesOverview from './views/vehicles-overview.vue'
import ServiceManagement from './views/service-details.vue'
import Invoices from './views/invoices.vue'
import ComingSoon from './views/coming-soon.vue'
import UpdateBrowser from './views/update-browser.vue'
import Error from './views/error.vue'
import DirectDebitCallback from './views/direct-debit-callback.vue'

import VehicleAppsOverview from './views/vehicle-apps-overview.vue'
import VehicleAppsDetail from './views/vehicle-apps-details.vue'
import AppLibraryOverview from './views/app-library-overview.vue'

import { ProductType } from '@/helpers/enums'
import store from './store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: (route: Route) => ({ token: route.query.token }),
    meta: { hideMenu: true }
  },
  {
    path: '/payment-confirmation',
    name: 'payment_confirmation',
    component: PaymentConfirmation,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-information',
    name: 'payment_information',
    component: PaymentInformation,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-method',
    name: 'payment_method',
    component: PaymentMethod,
    meta: { requiresAuth: true }
  },
  {
    path: '/vehicle-details/:id',
    name: 'vehicle_details',
    component: VehicleDetail,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: { name: 'portal-services' },
    children: [
      {
        path: 'services',
        name: 'services',
        component: ServiceOverview,
        meta: { requiresAuth: true }
      },
      {
        path: 'portal-services',
        name: 'portal-services',
        component: ServiceOverview,
        meta: { requiresAuth: true }
      },
      {
        path: 'data-services',
        name: 'data-services',
        component: ServiceOverview,
        meta: { requiresAuth: true }
      },
      {
        path: 'vehicle-apps',
        name: 'vehicleApps',
        component: VehicleAppsOverview,
        props: { vehicleAppType: ProductType.InVehicleApp },
        meta: { requiresAuth: true }
      },
      {
        path: 'third-party-apps',
        name: 'thirdPartyApps',
        component: VehicleAppsOverview,
        props: { vehicleAppType: ProductType.ThirdPartySolution },
        meta: { requiresAuth: true }
      },
      {
        path: 'vehicles',
        name: 'vehicles',
        component: VehiclesOverview,
        meta: { requiresAuth: true }
      },
      {
        path: 'app-library',
        name: 'appLibrary',
        component: AppLibraryOverview,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/service-detail/:id',
    name: 'service-detail',
    component: ServiceManagement,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/vehicle-app-detail/:id',
    name: 'vehicle-app-detail',
    component: VehicleAppsDetail,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: Invoices,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    component: ComingSoon,
    meta: { hideMenu: true }
  },
  {
    path: '/coming-soon',
    name: 'coming-soon',
    component: ComingSoon,
    meta: { hideMenu: true }
  },
  {
    path: '/update-browser',
    name: 'update-browser',
    component: UpdateBrowser,
    meta: { hideMenu: true }
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: { hideMenu: true }
  },
  {
    path: '/dd/:provider/:mandateNumber/:status/:template?/:signature?',
    name: 'direct-debit',
    component: DirectDebitCallback,
    props: true,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({ mode: 'history', routes })

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('userToken')) {
      next({
        path: '/error'
      })
      return
    }
    try {
      await store.dispatch('account/getAccountRelations')
    } catch (e) {
      console.warn('Failed to prefetch account relations:', e)
    }
    next()
  } else {
    next()
  }
})

export default router
